<!-- BANNER SLIDER -->
<div class="banner-slider">
  <div class="banner-wrapper" *ngIf="banners.length">
  <div class="slide" *ngFor="let banner of banners">
     <img
      [src]="BannerUrl + banner.banner"
      [alt]="banner.title"

    />
  </div>
  </div>
</div>
<!-- /BANNER SLIDER -->



<!-- SECTION -->
<div class="section">
  <!-- container -->
  <div class="container">
    <!-- row -->
    <div class="row">
      <!-- shop -->
      <div class="col-md-4 col-xs-6" *ngFor="let c of categories">
        <!-- <span>{{c.title}}</span> -->
        <a [routerLink]="['/product-category', getSlug(c.title)]">
          <div class="shop">
            <div class="shop-img">
              <img [src]="otherimageBaseUrl + c.image" alt="{{c.title}}" style="cursor: pointer;" (click)="selectCategory(c.id)">
            </div>
            <div class="shop-body">
              <h4 style="color: #0B3954;">{{c.title}} </h4>
              <!-- <a class="cta-btn">{{c.title}} <i class="fa fa-arrow-circle-right"></i></a> -->
            </div>
          </div>
        </a>
      </div>

      <!-- /shop -->


    </div>
    <!-- /row -->
  </div>
  <!-- /container -->
</div>
<!-- /SECTION -->




<!-- SECTION -->
<div class="section">
  <!-- container -->
  <div class="container">
    <!-- row -->
    <div class="row">

      <!-- section title -->
      <div class="col-md-12 search-results-section" #searchResultsSection >
        <div class="section-title">
          <h3 class="title">{{ searchQuery ? 'Search Results' : 'Trending Collections' }}
          </h3>

        </div>
      </div>
      <!-- /section title -->

      <!-- Products tab & slick -->
       <!-- Products display -->
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-4 col-sm-6" *ngFor="let p of products" style="margin-top: 20px;">
            <div class="card my-2">
              <img [src]="imageBaseUrl + p.image" alt="{{p.name}}" width="200px" class="card-img-top" style="cursor: pointer;"
                (click)="selectProduct(getSlug(p.name + ' ' + p.id))">
              <div class="card-header">
                <div class="card-title">
                  <p>{{p.name.substr(0, 30)  | titlecase}} ...</p>
                </div>
                 <p class="lead"><b>{{p.price | currency: 'INR'}}</b></p>
              </div>
              <!-- <div class="card-body">
                <h6>{{p.description.substr(0, 65)}} ...</h6>
                <p class="lead">{{p.price | currency: ''}}</p>
              </div> -->
              <div class="row d-flex justify-content-center border-primary my-3">
                <div class="col-md-6">
                  <button class="btn btn-outline-primary btn-sm btn-block" [class.disabled]="p.quantity < 1"
                    [class.btn-outline-danger]="p.quantity < 1" (click)="AddToCart(p.id)">
                    {{
                    p.quantity < 1 ? "SOLD OUT" : "Add to Cart" }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Products tab & slick -->
      </div>
      <!-- /row -->
         <!-- No results message -->
        <div *ngIf="products.length === 0 && searchQuery" class="text-center mt-4">
          <p>No products found for "{{ searchQuery }}"</p>
        </div>
    </div>
  </div>
</div>
<!-- /SECTION -->







